import AppImage from '@/components/AppImage'

export default function ImageAndTextImage({
  image,
  total,
  index,
}: {
  image: {
    url: string
    height: number
    width: number
    alt: string
  }
  total: number
  index: number
}) {
  const { url, alt } = image

  let colClass = ''
  let imgClass = 'w-full'
  let pictureSources = {}
  let transforms = {} as any

  if (total === 1) {
    colClass = 'col-span-2 row-span-2'

    transforms = {
      focus: 'center',
      dpr: 'auto',
      height: '540',
      width: '808',
      quality: '80',
    }
  } else if (total === 2) {
    colClass = ' ms-up:col-span-1 ms-up:row-span-2'

    transforms = {
      dpr: 'auto',
      height: '700',
      width: '602',
      quality: '80',
    }
  } else if (total === 3) {
    colClass = 'ms-up:col-span-1'
    colClass += index === 0 ? ' ms-up:row-span-2' : ' ms-up:row-span-1'

    transforms = {
      dpr: 'auto',
      height: index === 0 ? '700' : '338',
      width: '602',
      quality: '80',
    }
  }

  if (total > 1) {
    imgClass += ' absolute ms-up:object-cover ms-up:h-full'
  }

  // Mobile slider images
  pictureSources = {
    ...pictureSources,
    '(max-width: 769px)': { width: 714, height: 477 },
    '(max-width: 599px)': { width: 544, height: 364 },
    '(max-width: 399px)': { width: 352, height: 235 },
  }

  return (
    <AppImage
      path={`${url}?v=10`}
      alt={alt}
      height={Number(transforms.height)}
      width={Number(transforms.width)}
      loading="lazy"
      pictureClassName={`keen-slider__slide rounded-lg overflow-hidden relative w-full h-full ${colClass}`}
      className={`${imgClass} w-full`}
      // Default transform
      transforms={transforms}
      // Picture source transforms
      pictureSources={pictureSources}
    />
  )
}
